<template>
  <!-- 委託仕入（買掛金）登録/編集 -->
  <div class="egl-dialog-elm">
    <el-dialog
      :title="$locale('proxy.title')"
      :visible.sync="isShow"
      class="egl-dialog"
      :modal="false"
      :before-close="closeCallback"
      :modal-append-to-body="true"
      :show-close="true"
      ref="accountDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        label-width="40px"
        :model="form"
        class="setForm"
        ref="payableForm"
        :rules="rules"
        :disabled="actionType === 'view'"
      >
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("global.basicInfo") }}
          </div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="
                $locale('accountPayableManagement.accountsPayableDetails')
              "
              prop="name"
            >
              <el-input
                :placeholder="
                  $locale(
                    'accountPayableManagement.accountsPayableDetails.placeholder'
                  )
                "
                v-model="form.name"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$locale('accountPayableManagement.requestDate')"
              prop="requestDeadDate"
            >
              <CommDatePicker
                v-model="form.requestDeadDate"
                :value.sync="form.requestDeadDate"
                width="100%"
                :showWeekly="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$locale('accountPayableManagement.paymentDueDate')"
              prop="payDate"
            >
              <CommDatePicker
                v-model="form.payDate"
                :value.sync="form.payDate"
                width="100%"
                :showWeekly="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $locale('accountPayableManagement.recordedAmount/invoiceAmount')
              "
              prop="needPayAmount"
            >
              <el-input
                :placeholder="
                  $locale(
                    'accountPayableManagement.recordedAmount/invoiceAmount.placeholder'
                  )
                "
                v-model="form.needPayAmount"
                @input="(value) => priceFormat_forPayable(value, form, 'needPayAmount')"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item :label="$locale('accountPayable.billMonth')" prop="billMonthDate">
              <el-date-picker v-model="form.billMonthDate" type="month" value-format="timestamp"></el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
        <hr class="dotted" />
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("proxy.detail") }}
          </div>
          <el-tooltip :content="$locale('proxy.detail')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$locale('accountPayableManagement.targetTheaters')"
              prop="cinemaName"
            >
              <el-select
                popper-class="account-payable"
                multiple
                v-model="form.targetSourceList.cinemaIdList"
              >
                <MultiSelect :list.sync="form.targetSourceList.cinemaIdList" :dataList="cinemaList" />
                <el-option
                  v-for="item in cinemaList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                  <div class="select-item">
                    <i
                      class="el-icon-check"
                      v-show="
                        form.targetSourceList.cinemaIdList.indexOf(item.id) >=
                        0
                      "
                    ></i
                    >{{ item.name }}
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $locale('accountPayableManagement.targetBusinessPartners')
              "
              prop="clientName"
            >
              <!-- <el-select
                popper-class="account-payable"
                multiple
                v-model="form.targetSourceList.clientIdList"
                :filterable="true"
              >
                <MultiSelect :list.sync="form.targetSourceList.clientIdList" :dataList="clientList" />
                <el-option
                  v-for="item in clientList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                  <div class="select-item">
                    <i
                      class="el-icon-check"
                      v-show="
                        form.targetSourceList.clientIdList.indexOf(item.id) >=
                        0
                      "
                    ></i
                    >{{ item.name }}
                  </div>
                </el-option>
              </el-select> -->
              <!-- <template v-if="isShow">
                <remote-select
                  type="client"
                  v-model="form.targetSourceList.clientIdList"
                  :formValue.sync="form.targetSourceList.clientIdList"
                  :actionType="actionType === 'registration' ? 'create' : 'edit'"
                  @selectAll="arr => form.targetSourceList.clientIdList = arr"
                  :isSelectAllFunc="true"
                />
              </template> -->
              <RemoteSelectV2
                ref="selectV2"
                type="client"
                :list="comClientList"
                v-model="form.targetSourceList.clientIdList"
                :formValue.sync="form.targetSourceList.clientIdList"
                @setList="arr => comClientList = arr"
                @selectAll="arr => form.targetSourceList.clientIdList = arr"
                :isSelectAllFunc="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="period">
          <p>{{ $locale("proxy.period") }}</p>
          <div>
            <DatePickerGroup
              v-bind:start="form.targetSourceList.dateStartTime"
              v-bind:end="form.targetSourceList.dateEndTime"
              v-bind:max="Infinity"
              v-bind:isExp="true"
              @setFatherDate="getPeriod"
            />
            <el-button class="drawOut egl-btn-yellow" @click="extractionHandler">
              {{ $locale("accountPayableManagement.drawOut") }}
            </el-button>
          </div>
        </div>
        <el-table
          class="egl-table payTable"
          :data="tableData"
          @select="tableSelect"
          @select-all="tableSelect"
          show-summary
          :sum-text="
            $locale(
              'accountPayableManagement.theTotalAmountOfTheCompleteCollection'
            )
          "
          :summary-method="getSummaries"
          ref="payTable"
        >
          <el-table-column
            v-if="actionType !== 'view'"
            label=""
            width="80"
            type="selection"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.theaterName')"
            prop="cinemaName"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.customerName')"
            prop="clientName"
          ></el-table-column>
          <el-table-column
            :label="$locale('purchase.productName')"
            prop="storeName"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.targetPeriod')"
            prop="proxyBuy.dateInterval"
          ></el-table-column>
          <el-table-column
            :label="$locale('proxy.returnAmount')"
            prop="proxyBuy.actualPayAmount"
            :formatter="priceFormat"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.calculateTheAmount')"
            prop="proxyBuy.needPayAmount"
            align="center"
          >
            <template slot-scope="scope">
              <p
                :class="
                  scope.row.proxyBuy.actualPayAmount !==
                    scope.row.proxyBuy.needPayAmount ? 'red' : ''
                "
              >
                {{ format(scope.row.proxyBuy.needPayAmount) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="handle">
                <a @click="toggleDetail(scope.row.proxyBuy.uuid, scope.$index)">{{
                  $locale("global.detail")
                }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="tableData.length > 0" style="color: #898989; margin-top: 35px">
          {{ $locale("otherPurchase.detail") }}
        </p>
        <OtherPurchaseTable
          v-if="tableData.length > 0"
          v-bind:propData="this.form.targetSourceList.elseBuy"
          v-bind:cinemaList="cinemaList"
          v-bind:clientList="clientList"
          @callFatherFn="getChildMsg"
          ref="otherTable"
          :isOpen="isShow"
          :actionType="actionType"
        ></OtherPurchaseTable>
        <div class="summary">
          <p>
            {{ $locale("accountPayableManagement.totalAmountOfSelectionItems")
            }}<span>{{ format(totalSelectAmount) }}</span>
          </p>
          <p>
            {{
              $locale(
                "accountPayableManagement.differenceFromTheAmountStatedOnTheInvoice"
              )
            }}<span :class="totalSelectDiff !== 0 && 'red'">{{
              format(totalSelectDiff)
            }}</span>
          </p>
        </div>
      </el-form>

      <PaymentTable
        v-if="accountPayableArr.length > 0"
        v-bind:accountPayableArr="accountPayableArr"
        v-bind:actionType="actionType"
        @callFatherPayment="callFatherPayment"
      ></PaymentTable>

      <div slot="footer" class="dialog-footer" v-if="actionType !== 'view'">
        <el-button @click="closeCallback" class="egl-btn-white">{{ $locale("global.cancel") }}</el-button>
        <el-button
          @click="submit"
          :class="confirmBtnStyle ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="confirmBtnStyle"
        >{{ $locale("global.confirm") }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$locale('proxy.title')"
      :visible.sync="isDetailShow"
      class="egl-dialog detail"
      :modal="false"
      :before-close="beforeCloseDetail"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        label-width="40px"
        :model="detailForm"
        class="setForm"
      >
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("global.basicInfo") }}
          </div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$locale('accountPayableManagement.theaterName')"
            >
              <p>{{ detailForm.cinemaName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$locale('accountPayableManagement.customerName')"
            >
              <p>{{ detailForm.clientName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('purchase.productName')">
              <p>{{ detailForm.storeName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$locale('accountPayableManagement.targetPeriod')"
            >
              <p>{{ detailForm.duration }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('proxy.returnAmount')">
              <p>{{ formatRounding(detailForm.actualPayAmount) }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <hr class="dotted" />
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("proxy") }}
          </div>
          <el-tooltip :content="$locale('proxy')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-table
          :data="tableData_detail"
          class=""
        >
          <el-table-column
            :label="$locale('proxy.productSales')"
            prop="proxyBuy.saleAmount"
            :formatter="priceFormat"
          ></el-table-column>
          <el-table-column
            :label="$locale('proxy.purchasePrice')"
            prop="proxyBuy.productCost"
            :formatter="priceFormat"
          ></el-table-column>
          <el-table-column
            :label="$locale('proxy.number')"
            prop="proxyBuy.saleCount"
            :formatter="priceFormat"
          ></el-table-column>
           <el-table-column
            :label="$locale('proxy.returnAmount')"
            prop="proxyBuy.actualPayAmount"
            :formatter="priceFormat"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.calculateTheAmount')"
            prop="Amount"
          >
            <template slot-scope="scope">
              <el-input v-model="detailInput" @input="(value) => formPriceFormatProxy(value, scope.$index)" :disabled="actionType === 'view'" />
            </template>
          </el-table-column>
          <el-table-column
            :label="$locale('accPayMDetail.difference')"
            prop="difference"
          >
            <template>
              <p>{{format(DiffDetail)}}</p>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer payable" v-if="actionType !== 'view'">
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <el-button @click="beforeCloseDetail" class="egl-btn-white">
              {{ $locale("global.cancel") }}
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button @click="detailSave" class="egl-btn-yellow">
              {{ $locale("global.confirm") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import DatePickerGroup from "@/components/DatePickerGroup";
import MultiSelect from "@/components/common/MultiSelect";
import {
  accPayCreate,
  extraction,
  update,
} from "@/helpers/service/api/accPayManagement.js";
import { toThousands, priceFormat_forPayable, rounding, addCommas } from "@/utils/common.js";
// import { MessageBox } from "element-ui";
import OtherPurchaseTable from "@/components/AccountPayable/OtherPurchaseTable.vue";
import PaymentTable from "./PaymentTable.vue";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";
import { convertDateToJPTime } from "@/assets/js/accountPayable.js";
// const brandId = window.localStorage.getItem("brandId");
// let brandId;
export default {
  inject: [ "clientList" ],
  created() {
    this.brandId = window.localStorage.getItem("brandId");
  },
  data() {
    return {
      brandId: "",
      isDetailShow: false,
      cinemaList: JSON.parse(window.localStorage.getItem("cinemaObj")),
      form: {
        name: "",
        needPayAmount: "",
        requestDeadDate: 0,
        payDate: 0,
        // billMonthDate: this.$moment().startOf("month").valueOf(),
        targetSourceList: {
          cinemaIdList: [],
          clientIdList: [],
          dateStartTime: 0,
          dateEndTime: 0,
          source: [],
        },
      },
      detailForm: {
        cinemaName: "",
        clientName: "",
        storeName: "",
        duration: "",
        actualPayAmount: "",
      },
      tableData: [],
      tableData_detail: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$locale("accPayM.nameMsg"),
            trigger: "blur",
          },
        ],
        needPayAmount: [
          {
            required: true,
            message: this.$locale("accPayM.amount"),
            trigger: "blur",
          },
        ],
      },
      selectedTableData: [],
      // diffPrice: 0,
      curUid: 0,
      otherPurchasePrice: 0,
      otherPurchaseObj: {},
      detailInput: "",
      priceFormat_forPayable,
      comClientList: []
    };
  },
  computed: {
    today() {
      return this.$moment().startOf("day").valueOf();
    },
    totalReturnAmount() {
      let total = 0;
      this.tableData.forEach(item => {
        total += item.proxyBuy.actualPayAmount;
      });
      return total;
    },
    totalPayAmount() {
      let total = 0;
      this.tableData.forEach(item => {
        total += item.proxyBuy.needPayAmount;
      });
      return total;
    },
    totalSelectAmount() {
      let total = 0;
      this.selectedTableData.forEach(item => {
        total += item.proxyBuy.needPayAmount;
      });
      total += this.otherPurchasePrice;
      return total;
    },
    totalSelectDiff() {
      return this.totalSelectAmount - this.strToNumber(this.form.needPayAmount);
    },
    DiffDetail() {
      if (this.tableData_detail.length > 0) {
        return isNaN(this.strToNumber(this.detailInput)) ? 0 : this.strToNumber(this.detailInput) - this.tableData_detail[0].proxyBuy.actualPayAmount;
      }
      return 0;
    },
    confirmBtnStyle() {
      return this.totalSelectDiff !== 0 || this.tableData.length === 0 || this.selectedTableData.length === 0;
    },
    injectClientList() {
      return this.clientList();
    }
  },
  watch: {
    actionType(val) {
      if (val === "" || val === "registration") {
        this.form = {
          name: "",
          needPayAmount: "",
          requestDeadDate: Date.now().valueOf(),
          payDate: Date.now().valueOf(),
          // billMonthDate: this.$moment().startOf("month").valueOf(),
          targetSourceList: {
            cinemaIdList: [],
            clientIdList: [],
            dateStartTime: 0,
            dateEndTime: 0,
            source: [],
          },
        };
        return;
      }
      let total = 0;
      if (this.forMsg.targetSourceList.elseBuy) {
        this.forMsg.targetSourceList.elseBuy.forEach(item => {
          total += item.otherGoodsInfo.price * item.otherGoodsInfo.inventory;
        });
      }
      this.otherPurchasePrice = total;
      this.otherPurchaseObj = {
        data: this.forMsg.targetSourceList.elseBuy,
        total: this.otherPurchasePrice,
      };
      this.form = {
        name: this.forMsg.name,
        needPayAmount: this.forMsg.needPayAmount,
        requestDeadDate: this.forMsg.requestDeadDate,
        payDate: this.forMsg.payDate,
        targetSourceList: {
          cinemaIdList: this.forMsg.targetSourceList.cinemaIdList === null ? [] : this.forMsg.targetSourceList.cinemaIdList,
          clientIdList: this.forMsg.targetSourceList.clientIdList === null ?  [] : this.forMsg.targetSourceList.clientIdList,
          dateEndTime: this.forMsg.targetSourceList.dateEndTime,
          dateStartTime: this.forMsg.targetSourceList.dateStartTime,
          elseBuy: this.forMsg.targetSourceList.elseBuy,
          source: this.forMsg.targetSourceList.source,
        },

      };
      if (this.forMsg.type === "PROXY_BUY") {
        this.tableData = this.forMsg.targetSourceList.source;
        this.$nextTick(() => {
          this.$refs["payTable"].toggleAllSelection();
        });
      }
    },
    "form.targetSourceList.cinemaIdList"(arr, oldArr) {
      if (this.isShow && oldArr.length != 0 && oldArr.length > arr.length) {
        this.selectedTableData = [];
        this.tableData = [];
        this.form.targetSourceList.elseBuy = [];
      }
    },
    "form.targetSourceList.clientIdList"(arr, oldArr) {
      if (this.isShow && oldArr.length != 0 && oldArr.length > arr.length) {
        this.selectedTableData = [];
        this.tableData = [];
        this.form.targetSourceList.elseBuy = [];
      }
    },
    isShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["selectV2"].page = 1;
        });
        if (this.form.targetSourceList.clientIdList.length > 0) {
          getClientListService({
            ...this.form.targetSourceList.clientIdList ? { ids: this.form.targetSourceList.clientIdList } : {},
            page: 0,
            pageSize: this.form.targetSourceList.clientIdList.length > 0 ? 9999 : 20,
            field: ["id", "name"]
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.comClientList = this.$_.uniqBy(res.data.data.concat(this.injectClientList), "id");
              // this.$refs["selectV2"].page = 0;
              // if (this.form.targetSourceList.clientIdList.length === 0) this.$refs["selectV2"].page++;
            }
          });
        } else {
          this.comClientList = this.injectClientList;
        }
      }
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    clientList: {
      type: Array,
    },
    closeFn: {
      type: Function,
    },
    refreshTable: {
      type: Function,
    },
    actionType: {
      type: String,
      default: "view",
    },
    forMsg: {
      type: Object,
    },
    accountPayableArr: {
      type: Array,
      default: () => [],
    },
    roundType: {
      type: String,
      default: "",
    }
  },
  components: {
    CommDatePicker,
    DatePickerGroup,
    OtherPurchaseTable,
    PaymentTable,
    MultiSelect,
    RemoteSelectV2
  },
  methods: {
    formPriceFormatProxy(value) {
      this.detailInput = addCommas(value.replace(/,/g, ""));
    },
    getChildMsg(obj) {
      this.otherPurchaseObj = obj;
      this.otherPurchasePrice = obj.total;
      // this.diffPrice = toThousands(
      //   this.strToNumber(this.totalSelectedPrice) -
      //     this.strToNumber(this.form.actualAmountResidual)
      // );
    },
    strToNumber(str) {
      if (str === "") {
        return 0;
      } else if(typeof str === "number") {
        return str;
      }
      return parseFloat(str.replace(/,/g, ""));
    },
    beforeCloseHandler() {
      this.form.name = "";
      this.form.needPayAmount = "";
      this.form.requestDeadDate = this.today;
      this.form.payDate = this.today;
      this.form.targetSourceList.cinemaIdList = [];
      this.form.targetSourceList.clientIdList = [];
      this.form.targetSourceList.source = [];
      this.form.targetSourceList = {
        cinemaIdList: [],
        clientIdList: [],
        dateStartTime: 0,
        dateEndTime: 0,
        source: [],
      };
      this.tableData = [];
      this.selectedTableData = [];
      this.otherPurchasePrice = 0;
      this.otherPurchaseObj = {};
      this.$emit("closeFn");
    },
    beforeCloseDetail() {
      this.tableData_detail = [];
      this.detailForm = {
        actualPayAmount: "",
        cinemaName: "",
        clientName: "",
        duration: "",
        storeName: "",
      };
      this.isDetailShow = !this.isDetailShow;
    },
    closeCallback() {
      this.beforeCloseHandler();
      if (this.actionType === "edit") {
        this.$emit("refreshTable", undefined, false);
      }
    },
    submitCallback() {
      this.beforeCloseHandler();
      if (this.actionType === "edit") {
        this.$emit("refreshTable", this.$locale("global.updateSuccessfully"));
      } else {
        this.$emit("refreshTable");
      }
    },
    submit() {
      this.$refs.payableForm.validate(valid => {
        if (valid) {
          let data = {
            ...this.actionType === "edit" ? { id: this.forMsg.id } : {},
            brandId: this.brandId,
            needPayAmount: this.strToNumber(this.form.needPayAmount),
            name: this.form.name,
            payDate: this.form.payDate,
            requestDeadDate: this.form.requestDeadDate,
            targetSourceList: {
              cinemaIdList: this.form.targetSourceList.cinemaIdList,
              clientIdList: this.form.targetSourceList.clientIdList,
              dateStartTime: this.form.targetSourceList.dateStartTime,
              dateEndTime: this.form.targetSourceList.dateEndTime,
              elseBuy: this.otherPurchaseObj.data,
              source: this.selectedTableData,
            },
            type: "PROXY_BUY",
          };
          if (this.actionType === "edit") {
            update(data).then(() => this.submitCallback());
          } else {
            accPayCreate(data).then(() => this.submitCallback());
          }
        }
      });
    },
    getReqDate(num) {
      this.form = {
        ...this.form,
        requestDeadDate: num,
      };
    },
    getPayDate(num) {
      this.form = {
        ...this.form,
        payDate: num,
      };
    },
    selectHandler(method, form, listName) {
      form.targetSourceList[listName] = [];
      if (method === "select") {
        if (form.targetSourceList[listName].length < 5) {
          if (listName === "cinemaIdList") {
            this.cinemaList.forEach(item => {
              form.targetSourceList[listName].push(item.id);
            });
          } else {
            this.clientList.forEach(item => {
              form.targetSourceList[listName].push(item.id);
            });
          }
        }
      }
    },
    getPeriod(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.form.targetSourceList.dateStartTime = startDate;
      }
      if (endDate) {
        this.form.targetSourceList.dateEndTime = endDate;
      }
    },
    extractionHandler() {
      const that = this;
      if (
        this.form.targetSourceList.cinemaIdList.length === 0 ||
        this.form.targetSourceList.clientIdList.length === 0
      ) {
        this.$alert(`${this.$locale("accPayM.theater")} ${this.$locale("accPayM.client")} を選択してください`);
      } else {
        this.tableData = [];
        this.selectedTableData = [];
        this.form.targetSourceList.dateEndTime =
          this.form.targetSourceList.dateEndTime === 0
            ? this.today
            : this.form.targetSourceList.dateEndTime;
        this.form.targetSourceList.dateStartTime =
          this.form.targetSourceList.dateStartTime === 0
            ? this.today
            : this.form.targetSourceList.dateStartTime;
        extraction({
          brandId: this.brandId,
          cinemaIds: this.form.targetSourceList.cinemaIdList,
          clientIds: this.form.targetSourceList.clientIdList,
          dateEndTime: convertDateToJPTime(this.form.targetSourceList.dateEndTime).valueOf(),
          dateStartTime: convertDateToJPTime(this.form.targetSourceList.dateStartTime).valueOf(),
          type: "PROXY_BUY",
        }).then(res => {
          // this.tableData = res.data;
          let { data } = res;
          if (res.data.length > 0) {
            const keyNames = ["actualPayAmount", "needPayAmount", "saleAmount", "productCost", "saleCount"];

            data.map(item => {
              let itemClientId = item.proxyBuy.clientId;
              let fnName = "round";

              for (let i = 0; i < that.clientList.length; i++) {
                if (that.clientList[i].id == itemClientId) {
                  switch (that.clientList[i].round) {
                  case "ROUND":
                    fnName = "round";
                    break;
                  case "ROUND_UP":
                    fnName = "ceil";
                    break;
                  case "ROUND_DOWN":
                    fnName = "floor";
                    break;
                  default:
                    break;
                  }
                  break;
                }
              }

              keyNames.map(keyName => {
                item.proxyBuy[keyName] = Math[fnName](item.proxyBuy[keyName]);
              });
            });

            this.tableData = data;
            this.isShowSelect = !this.isShowSelect;
            let current = this.$el
              .querySelector(".payTable")
              .querySelector(".el-table__footer-wrapper");
            let cell = current.querySelectorAll("tbody tr td");
            cell[4].innerText = this.$locale("accountPayableManagement.theTotalAmountOfTheCompleteCollection");
            cell[0].innerText = "";
          }
        });
      }
    },
    tableSelect(value) {
      this.selectedTableData = value;
      // if (this.form.actualAmountResidual) {
      //   this.diffPrice = toThousands(
      //     this.strToNumber(this.totalSelectedPrice) -
      //       this.strToNumber(this.form.actualAmountResidual)
      //   );
      // } else {
      //   this.diffPrice = 0;
      // }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      if (this.tableData.length > 0) {
        columns.forEach((column, index) => {
          switch (index) {
          case 5:
            sums[index] = toThousands(rounding(this.totalReturnAmount, this.roundType, 2));
            break;
          case 6:
            sums[index] = toThousands(rounding(this.totalPayAmount, this.roundType, 2));
            break;
          default:
            break;
          }
        });
      }
      return sums;
    },
    toggleDetail(id, idx) {
      if (id !== undefined && idx !== undefined) {
        this.curUid = id;
        this.tableData.forEach(item => {
          if (id === item.proxyBuy.uuid) {
            this.detailForm = {
              cinemaName: item.cinemaName,
              clientName: item.clientName,
              storeName: item.storeName,
              duration: item.proxyBuy.dateInterval,
              actualPayAmount: item.proxyBuy.actualPayAmount === null ? 0 : toThousands(item.proxyBuy.actualPayAmount)
            };
            this.detailInput = item.proxyBuy.needPayAmount === null ? 0 : toThousands(item.proxyBuy.needPayAmount);
            let arr = [];
            arr.push(item);
            this.tableData_detail = arr;

            return;
          }
        });
      }
      this.isDetailShow = !this.isDetailShow;
    },
    detailSave() {
      let data = this.tableData;
      data.forEach(item => {
        if (this.curUid === item.proxyBuy.uuid) {
          item.proxyBuy.needPayAmount = this.strToNumber(this.detailInput);
        }
      });
      this.tableData = data;
      this.toggleDetail();
    },
    priceFormat(row, column) {
      if (row.proxyBuy) {
        if (column.property === "proxyBuy.actualPayAmount") {
          return row.proxyBuy.actualPayAmount === null ? "-" : toThousands(rounding(row.proxyBuy.actualPayAmount, this.roundType, 2));
        }
        // if (column.property === "proxyBuy.needPayAmount") {
        //   return row.proxyBuy.needPayAmount === null ? "-" : toThousands(row.proxyBuy.needPayAmount);
        // }
        if (column.property === "proxyBuy.saleAmount") {
          return row.proxyBuy.saleAmount === null ? "-" : toThousands(rounding(row.proxyBuy.saleAmount, this.roundType, 2));
        }
        if (column.property === "proxyBuy.saleCount") {
          return row.proxyBuy.saleCount === null ? "-" : toThousands(row.proxyBuy.saleCount);
        }
        if (column.property === "proxyBuy.productCost") {
          return row.proxyBuy.productCost === null ? "-" : toThousands(rounding(row.proxyBuy.productCost, this.roundType, 2));
        }
      }
    },
    format(value) {
      return toThousands(rounding(value, this.roundType, 2));
    },
    callFatherPayment(index, act) {
      this.$emit("showPaymentRegistration", -1, act, index);
    },
    formatRounding(val) {
      return toThousands(rounding(this.strToNumber(val), this.roundType, 2));
    }
  },
};
</script>

